<script lang="ts">
const __DsBlock = {
	icon: 'lucide:list-tree',
	name: '$t:blocks.collection_field_select.name',
	description: '$t:blocks.collection_field_select.description',
	category: 'system',
	tags: [],

	options: [
		{ name: 'modelValue', model: true },
		{ name: 'collectionId' },
		{ name: 'includePrimitiveFields' },
		{ name: 'includeRelationFields' },
	],
}
</script>
<script lang="ts" setup>
import type { GlobalCollectionId, GlobalPrimitiveFieldId, GlobalSingleRelationFieldId } from '#layers/data-model';

import { defineBlock } from '#layers/block-engine';

interface Props {
	collectionId: GlobalCollectionId;
	includePrimitiveFields?: boolean;
	includeRelationFields?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	includePrimitiveFields: true,
	includeRelationFields: true,
});

const modelValue = defineModel<GlobalPrimitiveFieldId | GlobalSingleRelationFieldId | null>({
	required: true,
});

;
</script>

<template>
	<CollectionFieldSelect
		v-bind="props"
		v-model="modelValue"
	/>
</template>
